const SCRATCH_3D_PROJECT_KIND = 'scratch3d.project';
const SCRATCH_3D_PROJECT_SCHEMA_VERSION = 2;
const SCRATCH_3D_EDITOR_MODE = '3d-only';
const SCRATCH_3D_DEFAULT_PROJECT_TITLE = '3D作品';
const SCRATCH_3D_DEFAULT_GRID_SIZE = 50;
const SCRATCH_3D_DEFAULT_INNER_BOUNDS = 30;
const SCRATCH_3D_DEFAULT_CELL_SIZE = 10;

const LOCAL_SCRATCH3D_PROJECT_STORAGE_KEY = 'scratch3d-editor-local-project-v2';
const LEGACY_LOCAL_3D_SCENE_STORAGE_KEYS = [
    'scratch3d-editor-local-scene-v1'
];

const clone = value => {
    if (typeof value === 'undefined') return value;
    return JSON.parse(JSON.stringify(value));
};

const safeFileName = title => {
    const normalized = String(title || '3D作品')
        .trim()
        .replace(/[\\/:*?"<>|]/g, '-');
    return normalized || '3D作品';
};

const projectTitleFromPayload = payload => {
    if (!payload || typeof payload !== 'object') return '';
    if (payload.project && payload.project.title) return payload.project.title;
    if (payload.title) return payload.title;
    if (payload.meta && payload.meta.title) return payload.meta.title;
    return '';
};

const createEmptyScratch3DSceneState = () => ({
    enabled: true,
    type: 'Scene2D5',
    schemaVersion: 1,
    gridSize: SCRATCH_3D_DEFAULT_GRID_SIZE,
    cellSize: SCRATCH_3D_DEFAULT_CELL_SIZE,
    outerBounds: SCRATCH_3D_DEFAULT_GRID_SIZE,
    innerBounds: SCRATCH_3D_DEFAULT_INNER_BOUNDS,
    background: '#dbeafe',
    customAssets: [],
    programming: {
        variables: [
            {value: 'score', label: '分数'},
            {value: 'energy', label: '能量'},
            {value: 'count', label: '数量'},
            {value: 'flag', label: '开关'}
        ],
        messages: [
            {value: 'startQuest', label: '开始任务'},
            {value: 'openSwitch', label: '打开机关'},
            {value: 'collected', label: '收集完成'},
            {value: 'levelClear', label: '通关成功'}
        ]
    },
    weather: {
        type: 'sunny',
        temperature: 24,
        windForce: 'medium',
        lighting: 'medium',
        ultraviolet: 'medium'
    },
    objects: {}
});

const editorStateFromPayload = payload => {
    if (!payload || typeof payload !== 'object') return null;
    if (payload.editorState && typeof payload.editorState === 'object') return clone(payload.editorState);
    if (payload.editor && payload.editor.state && typeof payload.editor.state === 'object') {
        return clone(payload.editor.state);
    }
    return null;
};

const sceneStateFromPayload = payload => {
    if (!payload || typeof payload !== 'object') return null;
    if (payload.scene && typeof payload.scene === 'object') return clone(payload.scene);
    if (payload.sceneState && typeof payload.sceneState === 'object') return clone(payload.sceneState);
    if (payload.scratch3D && typeof payload.scratch3D === 'object') return clone(payload.scratch3D);
    if (payload.objects || payload.customAssets || payload.programming) return clone(payload);
    return null;
};

const createScratch3DProjectPayload = (sceneState, options = {}) => {
    const title = options.title || projectTitleFromPayload(options) || SCRATCH_3D_DEFAULT_PROJECT_TITLE;
    const savedAt = options.savedAt || new Date().toISOString();
    const payload = {
        kind: SCRATCH_3D_PROJECT_KIND,
        schemaVersion: SCRATCH_3D_PROJECT_SCHEMA_VERSION,
        savedAt,
        editor: {
            name: 'Scratch 3D Editor',
            mode: SCRATCH_3D_EDITOR_MODE
        },
        project: {
            title
        },
        scene: clone(sceneState || {})
    };

    if (options.editorState && typeof options.editorState === 'object') {
        payload.editorState = clone(options.editorState);
    }

    return payload;
};

const normalizeScratch3DProjectPayload = (payload, options = {}) => {
    const sceneState = sceneStateFromPayload(payload);
    if (!sceneState) {
        throw new Error('Invalid Scratch 3D project payload');
    }
    return createScratch3DProjectPayload(sceneState, {
        ...options,
        title: options.title || projectTitleFromPayload(payload),
        savedAt: options.savedAt || payload.savedAt,
        editorState: options.editorState || editorStateFromPayload(payload)
    });
};

const parseScratch3DProjectText = text => {
    const payload = JSON.parse(text);
    const sceneState = sceneStateFromPayload(payload);
    if (!sceneState) {
        throw new Error('Invalid Scratch 3D project file');
    }
    return {
        payload,
        sceneState,
        editorState: editorStateFromPayload(payload),
        title: projectTitleFromPayload(payload)
    };
};

const scratch3DProjectFileName = title => `${safeFileName(title || SCRATCH_3D_DEFAULT_PROJECT_TITLE)}.scratch3d`;

export {
    LEGACY_LOCAL_3D_SCENE_STORAGE_KEYS,
    LOCAL_SCRATCH3D_PROJECT_STORAGE_KEY,
    SCRATCH_3D_DEFAULT_PROJECT_TITLE,
    SCRATCH_3D_EDITOR_MODE,
    SCRATCH_3D_PROJECT_KIND,
    SCRATCH_3D_PROJECT_SCHEMA_VERSION,
    createEmptyScratch3DSceneState,
    createScratch3DProjectPayload,
    editorStateFromPayload,
    normalizeScratch3DProjectPayload,
    parseScratch3DProjectText,
    projectTitleFromPayload,
    scratch3DProjectFileName,
    sceneStateFromPayload
};
